import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { JoinPage } from './JoinPage';

// The referrer's first name is appended to the share link.
const searchSchema = z.object({
  name: z.string().trim().min(1).max(40).optional().catch(undefined),
});

export const Route = createFileRoute('/join/$code/')({
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    if (context.auth.workOSUser) {
      throw redirect({ to: '/', replace: true });
    }
  },
  component: JoinPage,
});
